import React from 'react'

import { SVGProps } from '../../types/svg'
import COLORS from '../../styles/colors'

const defaultSize = {
  width: 34,
  height: 34,
}

function XSvg({ style, color = COLORS.uiSpecific.danger }: SVGProps) {
  return (
    <svg style={{ ...defaultSize, ...style }} viewBox='0 0 34 34'>
      <path
        d='M20.907 17.132L33.718 4.32a1.877 1.877 0 000-2.65L32.6.547a1.879 1.879 0 00-2.651 0L17.133 13.358 4.321.547a1.878 1.878 0 00-2.65 0L.548 1.67a1.875 1.875 0 000 2.65L13.36 17.132.548 29.943a1.879 1.879 0 000 2.651l1.123 1.122a1.878 1.878 0 002.65 0l12.812-12.811 12.812 12.811a1.859 1.859 0 001.325.547 1.86 1.86 0 001.325-.547l1.123-1.122a1.879 1.879 0 000-2.65z'
        fill={`${color}`}
      />
    </svg>
  )
}

export default XSvg
